import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FileIcon } from 'assets/icons/FileIcon.svg';
import { ReactComponent as MagicWandIcon } from 'assets/icons/MagicWandIcon.svg';

import { IOnePageDisplayMode, ONE_PAGE_DISPLAY_MODE } from '../types';

export const useGetExampleSwitchData = (mode: IOnePageDisplayMode) => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const example = { label: t('showExample'), icon: <MagicWandIcon /> };
    const optionsMap = new Map([
      [ONE_PAGE_DISPLAY_MODE.PROJECT, example],
      [ONE_PAGE_DISPLAY_MODE.EXAMPLE, { label: t('showMyProject'), icon: <FileIcon /> }],
    ]);

    return optionsMap.get(mode) ?? example;
  }, [t, i18n, mode]);
};
